module.exports = __webpack_public_path__ + "img/bg2.e35a14b9.png";